import { FC } from 'react'
import {
    AnswersBoxDate,
    AnswersBoxRadioAndChecked,
    AnswersBoxRadioImage,
    AnswersBoxSelect,
    AnswersWraper,
} from './AnswersBox.styled'
import { CheckedBtn } from './CheckedBtn/CheckedBtn'
import { DatePicker, DateTimeDataInfo } from './DatePicker/DatePicker'
import { RadioBtn } from './RadioBtn/RadioBtn'
import { RadioImageBtn } from './RadioImageBtn/RadioImageBtn'
import { RangeDataInfo, RangeSliderBtn } from './RangeSlider/RangeSlider'
import { RatingBtn, RatingDataInfo } from './RatingBtn/RatingBtn'
import { SelectBtn } from './SelectBtn/SelectBtn'
import { TextArea, TextDataInfo } from './TextArea/TextArea'
import { CheckedImageBtn } from './СheckedImageBtn/СheckedImageBtn'

export interface AnswerDataInfo {
    skip: boolean
    answer: unknown | DateTimeDataInfo | TextDataInfo | RatingDataInfo | RangeDataInfo
    options_answer: number[]
}

type Props = {
    answers: any[]
    questionType: number
    questionConfig: any
    value: AnswerDataInfo
    onChange: (value: AnswerDataInfo) => void
    isEditing?: boolean
}

export const AnswersBox: FC<Props> = ({ answers, questionConfig, questionType, value, onChange, isEditing }) => {
    return (
        <AnswersWraper>
            {questionType === 1 && (
                <AnswersBoxRadioAndChecked>
                    {answers.map(({ id, answer, emoji }) => (
                        <li key={id} style={{ height: '100%', alignSelf: 'stretch' }}>
                            {!questionConfig.multi_answers ? (
                                <RadioBtn
                                    name="radio-answer"
                                    text={answer}
                                    emoji={emoji}
                                    isChecked={value.options_answer.includes(id)}
                                    onChange={() => {
                                        onChange({ ...value, skip: false, options_answer: [id] })
                                    }}
                                />
                            ) : (
                                <CheckedBtn
                                    name="checked-answer"
                                    text={answer}
                                    emoji={emoji}
                                    isChecked={value.options_answer.includes(id)}
                                    onChange={(isChecked) => {
                                        const options_answer = isChecked
                                            ? [...value.options_answer, id]
                                            : value.options_answer.filter((item) => item !== id)
                                        onChange({ ...value, skip: false, options_answer })
                                    }}
                                />
                            )}
                        </li>
                    ))}
                </AnswersBoxRadioAndChecked>
            )}
            {questionType === 2 && (
                <AnswersBoxRadioImage>
                    {answers.map(({ id, answer, image }) => (
                        <li key={id}>
                            {!questionConfig.multi_answers ? (
                                <RadioImageBtn
                                    name="radio-image-answer"
                                    text={answer}
                                    image={image}
                                    isChecked={value.options_answer.includes(id)}
                                    onChange={() => {
                                        onChange({ ...value, skip: false, options_answer: [id] })
                                    }}
                                />
                            ) : (
                                <CheckedImageBtn
                                    id={`${id}`}
                                    name="checked-image-answer"
                                    text={answer}
                                    image={image}
                                    isChecked={value.options_answer.includes(id)}
                                    onChange={(isChecked) => {
                                        const options_answer = isChecked
                                            ? [...value.options_answer, id]
                                            : value.options_answer.filter((item) => item !== id)
                                        onChange({ ...value, skip: false, options_answer })
                                    }}
                                />
                            )}
                        </li>
                    ))}
                </AnswersBoxRadioImage>
            )}
            {questionType === 3 && (
                <AnswersBoxSelect>
                    <SelectBtn
                        options={answers.map(({ id, answer }) => ({
                            value: id,
                            label: answer,
                        }))}
                        onChange={(selected) => {
                            onChange({ ...value, skip: false, options_answer: [selected] })
                        }}
                    />
                </AnswersBoxSelect>
            )}
            {questionType === 4 && (
                <AnswersBoxSelect>
                    <TextArea
                        value={(value.answer ?? { value: '' }) as TextDataInfo}
                        onChange={(data) => {
                            onChange({ ...value, skip: false, answer: data })
                        }}
                    />
                </AnswersBoxSelect>
            )}
            {questionType === 5 && (
                <AnswersBoxSelect>
                    <RatingBtn
                        value={(value.answer as RatingDataInfo) ?? {}}
                        format={questionConfig.format}
                        quantity={questionConfig.quantity}
                        onChange={(data) => {
                            onChange({ ...value, skip: false, answer: data })
                        }}
                    />
                </AnswersBoxSelect>
            )}
            {questionType === 6 && (
                <AnswersBoxDate>
                    <DatePicker
                        value={
                            (value.answer ?? {
                                date: undefined,
                                time: {},
                            }) as DateTimeDataInfo
                        }
                        date_range={questionConfig.date_range}
                        with_time={questionConfig.with_time}
                        onChange={(data) => {
                            // console.log(data);
                            onChange({ ...value, skip: false, answer: data })
                        }}
                    />
                </AnswersBoxDate>
            )}
            {questionType === 7 && (
                <AnswersBoxSelect>
                    <RangeSliderBtn
                        value={
                            (value.answer && Object.keys(value.answer).length
                                ? value.answer
                                : {
                                      value: [questionConfig.min, questionConfig.max],
                                  }) as RangeDataInfo
                        }
                        range={questionConfig.is_range}
                        min={questionConfig.min ?? 0}
                        max={questionConfig.max ?? (questionConfig.min ?? 0) + 1}
                        step={questionConfig.step ?? 1}
                        onChange={(data) => {
                            onChange({ ...value, skip: false, answer: data })
                        }}
                        isEditing={isEditing}
                    />
                </AnswersBoxSelect>
            )}
        </AnswersWraper>
    )
}
